export default "__VITE_ASSET__Cr16ABGV__"